import React from "react";
import { ReactComponent as Checkmark } from "../assets/icons/checkmark.svg";
import { ReactComponent as Exclamation } from "../assets/icons/InfoNotification.svg";
import { ReactComponent as Cross } from "../assets/icons/ErrorNotification.svg";
import { toast } from "react-toastify";
import moment from "moment";
import { isEmptyObject } from "jquery";

const iconLookup = {
  success: <Checkmark />,
  info: <Exclamation />,
  error: <Cross />,
};

export const notify = (text, type = "success", icon = null) => {
  if(type !== "error"){
    toast(text, {
    type: type,
    icon: () => (icon ? icon : iconLookup[type]),
    closeButton: false,
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    theme: "colored",
  });
  }else {
    console.log(type,text);
  }
  // toast(text, {
  //   type: type,
  //   icon: () => (icon ? icon : iconLookup[type]),
  //   closeButton: false,
  //   position: "top-right",
  //   autoClose: 5000,
  //   hideProgressBar: true,
  //   closeOnClick: true,
  //   pauseOnHover: true,
  //   draggable: false,
  //   theme: "colored",
  // });
};

export const getInitials = (name) => {
  if (!name || name?.length === 0) {
    return "?";
  }
  name = name.split(" ");
  let initials = "";
  if (name.length > 1) {
    initials = `${name[0].charAt(0)}${name[1].charAt(0)}`;
  } else if (name[0].length > 1) {
    initials = `${name[0].charAt(0)}${name[0].charAt(1)}`;
  } else {
    initials = name[0].charAt(0);
  }
  return initials.toUpperCase();
};

export const formDataHelper = (formData, ignoreBlanks = false) => {
  const result = {};
  for (const [key, value] of formData.entries()) {
    if (ignoreBlanks) {
      if (value && value !== "null") {
        result[key] = value;
      }
    } else {
      result[key] = value;
    }
  }

  return result;
};

export const getCountOfInactive = (last_active) => {
  const today = new Date();
  today.setDate(today.getDate() - 30);
  const lastActive = new Date(last_active);
  return lastActive < today;
};

export const getTagBasedOnScore = (score, tag_group) => {
  let tags = [];
  if (tag_group)
    // eslint-disable-next-line prefer-destructuring
    tags = tag_group.tags;
  if (tags.length === 0) return "No Tag Group";

  let returnTag = "";

  tags.forEach((element) => {
    if (score >= element.low_bound && score <= element.high_bound)
      returnTag = element.label;
  });

  return returnTag;
};

export const getMaxScoreBasedOnAnswerGroups = (answer_group, questionnaire) => {
  return (
    answer_group?.answers[answer_group?.answers.length - 1]?.score *
      questionnaire?.length || 0
  );
};

export function generateYAxisTicks(numbers) {
  numbers = new Set(numbers);
  numbers = Array.from(numbers);
  if (numbers.length === 0) {
    return [];
  }

  function generateEvenlySpreadArray(numbers) {
    const maxNumber = Math.max(...numbers);
    const interval = maxNumber / 4;
    const evenlySpreadArray = [];

    for (let i = 0; i < 5; i++) {
      const value = Math.round(i * interval);
      evenlySpreadArray.push(value);
    }

    return evenlySpreadArray;
  }
  const yAxisLookup = ["😭 Awful", "😢 Bad", "🙂 Okay", "😁 Good", "😄 Great"];
  const yAxisNumbers = {};

  function roundUpToMultipleOfTwo(numbers) {
    const roundedNumbers = [];

    for (const number of numbers) {
      const rounded = Math.ceil(number / 2) * 2;
      roundedNumbers.push(rounded);
    }

    return roundedNumbers;
  }

  const sequence = generateEvenlySpreadArray(numbers);
  roundUpToMultipleOfTwo(sequence).forEach((item, index) => {
    yAxisNumbers[item] = yAxisLookup[index];
  });

  return yAxisNumbers;
}

export const selectDateFilter = (
  timespan,
  today,
  endDate,
  setStartDate,
  setEndDate
) => {
  if (timespan === "Past Week" || timespan === "pastweek") {
    const pastWeekStartDate = moment(endDate)
      .subtract(13, "days")
      .format("YYYY-MM-DD");
    const pastWeekEndDate = moment(endDate)
      .subtract(6, "days")
      .format("YYYY-MM-DD");
    setStartDate(pastWeekStartDate);
    setEndDate(pastWeekEndDate);
  }
  if (timespan === "This Week" || timespan === "week") {
    const pastWeekStartDate = moment(endDate)
      .subtract(6, "days")
      .format("YYYY-MM-DD");
    setStartDate(pastWeekStartDate);
    setEndDate(today);
  }

  if (timespan === "2 Week" || timespan === "2week") {
    const pastWeekStartDate = moment(endDate)
      .subtract(13, "days")
      .format("YYYY-MM-DD");
    setStartDate(pastWeekStartDate);
    setEndDate(today);
  }

  //TODO: Fix this
  if (timespan === "This Month" || timespan === "month") {
    const pastWeekStartDate = moment(endDate)
      .subtract(1, "month")
      .format("YYYY-MM-DD");
    setStartDate(pastWeekStartDate);
    setEndDate(today);
  }
  if (timespan === "3 Months" || timespan === "3months") {
    const pastWeekStartDate = moment(endDate)
      .subtract(3, "month")
      .format("YYYY-MM-DD");
    setStartDate(pastWeekStartDate);
    setEndDate(today);
  }
  if (timespan === "6 Months" || timespan === "6months") {
    const pastWeekStartDate = moment(endDate)
      .subtract(6, "month")
      .format("YYYY-MM-DD");
    setStartDate(pastWeekStartDate);
    setEndDate(today);
  }
};

export const getToday = () => {
  let today = new Date();
  today = moment(today).format("YYYY-MM-DD");
  return today;
};

export const bytesToSize = (bytes, seperator = "") => {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes == 0) return "n/a";
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes}${seperator}${sizes[i]}`;
  return `${(bytes / 1024 ** i).toFixed(1)}${seperator}${sizes[i]}`;
};

export const getPrivilegeExipryRTM = (expirationTime = 36000) => {
  const expirationTimeInSeconds = expirationTime;
  const currentTimestamp = Math.floor(Date.now() / 1000);
  const privilegeExpiredTs = currentTimestamp + expirationTimeInSeconds;
  return privilegeExpiredTs;
};

export const smartJoin = (array) => {
  return [...array.slice(0, -2), array.slice(-2).join(" and ")].join(", ");
};

export const capitalizeText = (string) => {
  return string.replace(/\b\w/g, (l) => l.toUpperCase());
};

export const urlify = (text) => {
  var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
  //var urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, function (url, b, c) {
    var url2 = c == "www." ? "http://" + url : url;
    return '<a href="' + url2 + '" target="_blank">' + url + "</a>";
  });
};

export const playMessageSound = (type = "incoming") => {
  const soundHashmap = {
    incoming: "incomingMessageSound",
    activeChat: "activeChatMessageSound",
  };
  try {
    const soundElement = document.getElementById(
      soundHashmap[type] || soundHashmap["incoming"]
    );

    if (soundElement) {
      soundElement.muted = false;
      try {
        soundElement.stop();
      } catch (e) {}
      soundElement.play();
    } else {
      //* Just in case the audio element was not found.
      notify("You have a new message!", "info");
    }
  } catch (e) {
    console.log(
      "Something went wrong while playing message sound!\nShowing info-card instead."
    );
    notify("You have a new message!", "info");
  }
};

export const generateMonthlyObjectsReverse = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // JavaScript months are zero-based, so we add 1.

  const months = [];
  for (let month = currentMonth; month >= 1; month--) {
    const monthLabel = new Date(currentYear, month - 1).toLocaleString(
      "en-us",
      { month: "short" }
    );
    const monthValue = `${currentYear}-${month.toString().padStart(2, "0")}-01`;
    months.push({ label: `${monthLabel} ${currentYear}`, value: monthValue });
  }

  return months;
  // Usage example:
  // const monthlyObjectsReverse = generateMonthlyObjectsReverse();
  // console.log(monthlyObjectsReverse);
};

export const findPrevMonth = (target) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear(); //2023
  const currentMonth = currentDate.getMonth(); //Starts from 0
  if (currentMonth !== 0) {
    const selectedDate = new Date(target?.value || target);
    return `${selectedDate.getFullYear()}-${
      selectedDate.getMonth() < 10
        ? "0" + selectedDate.getMonth()
        : selectedDate.getMonth()
    }-01`;
  }
  return `${currentYear - 1}-12-01`;
};

export const findClinician = (staffData, clinicianID) => {
  const targetStaff = staffData.find((e) => {
    if (e?.id === clinicianID) {
      return e;
    }
  });
  return targetStaff;
};

export const getFullName = (personObject) => {
  if (isEmptyObject(personObject)) {
    return "";
  }
  return `${personObject?.first_name} ${personObject?.last_name}`;
};

export const reportStatus = (bhiPatient, id) => {
  let status = "not ready";
  if (bhiPatient?.length > 0) {
    const target = bhiPatient.find((ele) => {
      if (ele.id === id) {
        return ele;
      }
    });
    if (target) {
      status = "ready";
    }
  }

  return status;
};

export const sortDates = (datesArray) => {
  try {
    const res = datesArray.sort((a, b) => {
      return new Date(a) - new Date(b);
    });

    return res;
  } catch (e) {
    return false;
  }
};

export const formatUTC = (dateInt, addOffset = false) => {
  let date = !dateInt || dateInt.length < 1 ? new Date() : new Date(dateInt);
  if (typeof dateInt === "string") {
    return date;
  } else {
    const offset = addOffset
      ? date.getTimezoneOffset()
      : -date.getTimezoneOffset();
    const offsetDate = new Date();
    offsetDate.setTime(date.getTime() + offset * 60000);
    return offsetDate;
  }
};

export const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const getPastMonthsListWithNames = (numMonths) => {
  const currentDate = new Date();
  const monthsList = [];
  const cmonthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  for (let i = 0; i < numMonths; i++) {
    const monthName = cmonthNames[currentDate.getMonth()];
    const year = currentDate.getFullYear();
    monthsList.push(`${monthName} ${year}`);

    // Move back one month for the next iteration
    currentDate.setMonth(currentDate.getMonth() - 1);
  }
  return monthsList;
};
